import React, { useState, useEffect, useMemo } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "../../components/MDBox";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDTypography from "../../components/MDTypography";
import Card from "@mui/material/Card";

import UBKSelect from "components/UBKSelect";
import UBKRadio from "components/UBKRadio";
import UBKSubmit from "../../components/UBKSubmit";
import toast, { Toaster } from "react-hot-toast";
import useSWR, { mutate as globalMutate } from "swr";
import { Select } from "antd";

import {
  getNewData,
  addData,
  deleteData,
  updateData,
  examdropdownUrl,
  getadmindataUrl,
  getAdminbranchDataUrl as cachekey,
  classUrl as cacheKeyClass,
} from "../../Api/api";

import { addOptions, deleteTodoOptions } from "../../Api/apiOption";
// import EditBranch from "./EditBranch ";
import UBKSelectMul from "../../components/UBKSelectMul";
import { useNavigate } from "react-router-dom";
import { Input, Radio } from "antd";
import MDInput from "../../components/MDInput";

function TemplateSettings() {
  //const navigate=useNavigate();

  const [examUrl, setExamUrl] = useState(null);
  const { isLoading: LoadingClass, data: classes } = useSWR(
    cacheKeyClass + "?branchID=22",
    getNewData
  );

  console.log("sssssssssssssss", classes);
  // const [formData, setFormData] = useState({
  //   exam_id: "",
  // });

  const {
    isLoading: isLoadingExam,
    errorExam,
    data: examList,
  } = useSWR(examdropdownUrl + "?branchID=22", getNewData);

  const handleSelect = (value) => {
    console.log("aaaaaaaaa", value);

    setExamUrl(`${examdropdownUrl}?class_id=${value}`);
  };

  const [value, setValue] = useState(1);
  const onChange = (e) => {
    setValue(e.target.value);
  };

  const style = {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  const PrintType = [
    {
      value: "Portrait",
      label: "Portrait",
    },
    {
      value: "Landscape",
      label: "Landscape",
    },
  ];

  const YesNoType = [
    {
      value: "Yes",
      label: "Yes",
    },
    {
      value: "No",
      label: "No",
    },
  ];
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Toaster toastOptions={{ position: "top-center" }} />
      <MDBox pt={8} pb={1}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={1}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Report Card Template
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <>
                  <Grid ml={2} item xs={12}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={3}>
                        <MDInput
                          required="required"
                          name="template_name"
                          type="text"
                          label="Template"
                        />
                      </Grid>

                      <Grid item xs={12} md={3}>
                        <MDInput
                          required="required"
                          name="template_name"
                          type="text"
                          label="Marksheet Type"
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <UBKRadio

                          options={PrintType}
                          name="call_type"
                          label="Print Type"
                          required="required"
                        ></UBKRadio>
                      </Grid>


                      <Grid item xs={12} md={3}>
                        <UBKSelectMul
                          mode="multiple"

                          style={{ width: "100%" }}
                          placeholder="Please select"
                          label="Please select"
                          // onChange={handleChange}
                          options={classes}
                        />
                      </Grid>
                  
                        <Grid item xs={12} md={3}>
                        <UBKRadio

                          options={YesNoType}
                          name="call_type"
                          label="Student Name"
                          required="required"
                        ></UBKRadio>
                      </Grid>
                        <Grid item xs={12} md={3}>
                        <UBKRadio

                          options={YesNoType}
                          name="call_type"
                          label="Father Name"
                          required="required"
                        ></UBKRadio>
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <MDBox>
                          <UBKRadio
                        
                            options={YesNoType}
                            name="Mother Name"
                            label=" Name"
                            ></UBKRadio>
                            </MDBox>
                        </Grid>
                      <Grid item xs={12} md={3}>
                        <MDBox>
                          <UBKRadio
                        
                            options={YesNoType}
                            name="Academic Session"
                            label=" Name"
                            ></UBKRadio>
                            </MDBox>
                        </Grid>
                      <Grid item xs={12} md={3}>
                        <MDBox>
                          <UBKRadio
                            options={YesNoType}
                            name="Admission No"
                            label=" Name"
                            ></UBKRadio>
                            </MDBox>
                        </Grid>
                      <Grid item xs={12} md={3}>
                        <MDBox>
                          <UBKRadio
                        
                            options={YesNoType}
                            name="Roll No."
                            label=" Name"
                            ></UBKRadio>
                            </MDBox>
                        </Grid>
                        

                      

                      <Grid item xs={12} md={3}>
                        <MDBox>
                          <UBKSelect
                            options={Array.isArray(examList) ? examList : []}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            label="Exam"
                            name="exam_id"
                            allowSelectAll={false}
                            required={true}
                          />
                        </MDBox>

                      </Grid>
                      {/* <Grid item xs={12} md={3} display={"flex"} alignItems={"center"}>
                          <Grid container>
                            <Grid item>
                              <MDBox>
                                <UBKSubmit
                                  style={{ marginTop: "28px" }}
                                  type="submit"
                                  value="Search"
                                  color="primary"
                                />
                              </MDBox>
                            </Grid>
                          </Grid>
                        </Grid> */}
                    </Grid>
                  </Grid>
                </>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default TemplateSettings;
